import React, { Component } from 'react';

import './Ideas.scss';

class Ideas extends Component {
    render() {
        return (
            <div className="Ideas">
                <div className="ideas-content content-section">

                    <h1>You could be TEDxPortland’s next speaker. Share your Idea Worth Spreading in the Ideas Booth for a chance to speak at this year’s event. </h1>

                    <div className="content-column video">
                    <iframe width="100%" src="https://www.youtube.com/embed/2XXdjA5auMA?controls=0?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                    <div className="content-column">
                        <p>
                        Back by popular demand, the Ideas Booth returns for its second year.
                        </p>
                        <p>
                        After overwhelming success last year — with over 250 submissions — not one, but two speakers were selected to take the TEDxPortland stage at Keller Auditorium.
                        </p>
                        <p>
                        This year, our speaker program has room for one more person — and it could be you! TEDxPortland is calling for anybody who has an Idea Worth Spreading! 
                        </p>
                    </div>
                    <div className="content-column"> 
                        <p>
                        <span>Dates / Times:</span>
                        March 22 – April 2<br/>
                        Lobby hours are 10am-5pm Monday - Saturday, and 12pm-5pm on Sundays.
                        </p>
                        <p>
                        <span>Location: </span>
                        Oregon Historical Society
                        1200 SW Park Avenue, 
                        Portland, OR 97205 
                        </p>
                        <p>
                        <span>Details:</span>
                        Visit the Ideas Booth to share your Idea through the StoryTap platform in 90 seconds or less. If your Idea is chosen, you will be selected to present on stage at the Keller Auditorium on April 27 in front of 3,000+ attendees
                        </p>
                        <p>
                        The selected speaker will receive a speaker coach and a professional graphic designer to assist with visuals.
                        </p>
                        <p>
                        Good luck!
                        </p>
                    </div>

                    <div className="content-column video"> 
                    <iframe width="100%" src="https://www.youtube.com/embed/pw2Tpwf0vIs" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                    <div className="content-column"> 
                        <p>
                            Congratulations to <a href="https://www.youtube.com/watch?v=NJoAF4oj_oM" target="_blank">Steve Eberlein</a> and <a href="https://www.youtube.com/watch?v=ayxYrTjsMUY" target="_blank">Kristine Napper</a> for their efforts in 2018.
                        </p>
                        <p>
                        Thank you to our partners at <a href="https://www.ohs.org" target="_blank">Oregon Historical Society</a>, <a href="https://storytap.com" target="_blank">StoryTap</a>, <a href="https://www.planar.com" target="_blank">Planar</a>, <a href="http://www.flatlinefabrication.com" target="_blank">Flatline Fabrication</a>, <a href="https://www.wearevictory.com" target="_blank">Victory</a>, and <a href="https://www.spacemonkeydesigns.com" target="_blank">Space Monkey Designs</a>
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default Ideas;